import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';

import { PromoteCreateButton } from './PromoteCreateButton';

export const PromoteEmptyPostList = () => {
  const { t } = useStore();
  return (
    <Fragment>
      <PromoteCreateButton />

      <Stack space={4} style={{ height: '100%' }} align="center" justify="center">
        <Text font="yuge">
          <span role="img" aria-label="shocked">
            😯
          </span>
        </Text>
        <Stack space={2} align="center">
          <Text font="heading1">{t('jobboards.emptyposts.heading')}</Text>
          <Text font="regular16" style={{ maxWidth: '420px' }}>
            {t('jobboards.emptyposts.text')}
          </Text>
        </Stack>
        <Link to="new">
          <Button text={t('jobboards.create')} />
        </Link>
      </Stack>
    </Fragment>
  );
};
